import script from "./NotSupported.vue?vue&type=script&setup=true&lang=js"
export * from "./NotSupported.vue?vue&type=script&setup=true&lang=js"

import "./NotSupported.vue?vue&type=style&index=0&id=5b5617c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b5617c3"]])

export default __exports__